import React, { useState , useEffect} from "react";
import "./App.css";
import MainPage from "./page/MainPage/MainPage";
import Login from "./page/Login";
import { ResetPasswordDisconnected } from "./page/MotDePasseOublie/ResetPassword";
import ToolBar from "./component/ToolBar";
import MotDePasseOublie from "./page/MotDePasseOublie";
// import { ReactInternetSpeedMeter } from "react-internet-meter";
import ReactGA from "react-ga4";
import { setAuthToken } from "./api";
import InterfaceRegistration from "./page/UserRegister/Register";
import { CGUDisconnected } from "./component/CGUDisconnected/CGU";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DownloadLink } from "./page/downloadLink";
import { ExpiredLink } from "./page/ExpiredLink";
import { QueryClient, QueryClientProvider } from 'react-query';
import { instance } from "./api"; 
import OverlayLogout from "./component/OverlayLogout";
function GlobalInterceptor() {
  const [showOverlay, setShowOverlay] = useState(false);
  useEffect(() => {
    const resInterceptor = instance.interceptors.response.use(
      res => res,
      error => {
        const status = error.response?.status;

        if (status === 403) {
           setShowOverlay(true); 
           setTimeout(()=>{
            sessionStorage.clear();
          window.location.href = "/";
           },3000);
          
        }
        return Promise.reject(error);
      }
    );

    // Nettoyage à la destruction du composant
    return () => {
      instance.interceptors.response.eject(resInterceptor);
    };
  }, []);

   return (
    <>
      {showOverlay && <OverlayLogout />}
    </>
  );
}

//import GlobalInterceptor from "./axiosInstance";
function App() {
  //useUserPing()
 
  ReactGA.initialize('G-SNK905T4E1');
  // Send pageview with a custom path
  useEffect(() => { ReactGA.send({ hitType : "pageview", page : window.location.pathname }) ; }, []) ;
  const [checked, setChecked] = useState(false);
  // const toast = useRef(null);
  // const [checkSpeed, SetCheckSpeed] = React.useState(false);
  //check jwt token
  const token = sessionStorage.getItem("token");
  const queryClient = new QueryClient();
  if (token) {
    setAuthToken(token);
  }

  return (
    <QueryClientProvider client={queryClient}>
       <GlobalInterceptor /> 
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <div className="flex flex-column" >
                <ToolBar  />
                <Login
                 setChecked={setChecked}
                  checked={checked}
              />
              </div>
            }
          />
   {/* <Route
            exact
            path="/connexion"
            element={
              <div>
                <ToolBar />
                <Login
           setChecked={setChecked}
                  checked={checked}
               />
              </div>
            }
          /> */}
          <Route
            exact
            path="/enregistrement/:utilisateurId/:token"
            element={
              <div>
                <ToolBar /> <InterfaceRegistration />{" "}
              </div>
            }
          />
          <Route
            exact
            path="/reinitialisation/:utilisateurId/:token"
            element={
              <div>
                <ToolBar /> <ResetPasswordDisconnected />{" "}
              </div>
            }
          />
          <Route
            exact
            path="/CGUDisconnected"
            element={
              <div>
                <ToolBar /> <CGUDisconnected />{" "}
              </div>
            }
          />
          {/* <Route exact path="/accueil/test" element={<HomeApp />} /> */}
          {/* <Route exact path="/gexpertise" element={<Gex />} /> */}

          <Route
            path="/*"
            element={
              <MainPage 
              checked={checked}
            
              />      
            }
          />
          <Route
            exact
            path="/MotDePasseOublie"
            element={
              <>
                <ToolBar />
                <MotDePasseOublie />
              </>
            }
          />
          <Route path="/expired" element={<ExpiredLink />} />
          <Route path="/telechargement" element={<DownloadLink />} />
        </Routes>
      </BrowserRouter>
    </div>
    </QueryClientProvider>
  );
}

export default App;
